<template>
  <div class="list" :class="{ 'no-hover': !hover, 'no-pointer': !pointer }">
    <slot name="header">
      <slot name="subheader">
        <div v-if="subheader" class="subheader">{{ subheader }}</div>
      </slot>
    </slot>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    subheader: String,
    append: String,
    hover: {
      type: Boolean,
      default: true,
    },
    pointer: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  padding: 8px 0;

  .subheader {
    padding: 4px 20px 7px 20px;
    color: #6e6b7b;
    font-size: 14px;
  }
}
</style>
